// import { TOKEN, scope,ORG_ID } from "@/utils/CustomConfigKeys";
// import request from "@/utils/request";
// import { queryString } from 'qs';

import * as ax from "./instrance";
import config from "../../config/config.js";
import axios from "axios";
import qs from "qs";
var URL = config.apiUrl;
var login = config.login;
var JflowURL = config.JflowURL;
var serviceName = "";

export function queryString(str) {
  return qs.stringify(str, { allowDots: true, indices: false });
}

// 极验 登录
export function getGtCaptcha(id) {
  return ax.g(`/gee/valid?timeStamp=${id}&client=web`);
}

// 短信验证码登录接口
export function loginBySms(data) {
  return request.post(
    `/auth/mobile/token/sms?${queryString(data)}`,
    {},
    {
      headers: {
        isToken: false,
        ORG_ID: "1",
        Authorization: "Basic Y2huX2g1X3YzMDp2MzBfY2huX2g1"
      }
    }
  );
}

// 账号密码登录接口
export function loginByUsername(data) {
  return axios({
    url: login + `/auth/oauth/token?${queryString(data)}`,
    headers: {
      isToken: false,
      ORG_ID: "1",
      Authorization: "Basic Y2huX2g1X3YzMDp2MzBfY2huX2g1"
    },
    method: "post"
  });

  // return ax.post(
  //   `/auth/oauth/token?${queryString(data)}`,
  //   {},
  //   {
  //     headers: {
  //       isToken: false,
  //       [ORG_ID]: "1",
  //       Authorization: "Basic Y2huX2g1X3YzMDp2MzBfY2huX2g1"
  //     }
  //   }
  // );
}

// 微信验证登录
export function loginByWechat(data) {
  return axios({
    url: config.login + `/auth/mobile/token/social?${queryString(data)}`,
    headers: {
      isToken: false,
      [ORG_ID]: "1",
      Authorization: "Basic Y2huX2g1X3YzMDp2MzBfY2huX2g1"
    },
    method: "post"
  });
}

// 刷新token
export function refreshToken(refresh_token) {
  const grant_type = "refresh_token";
  return request({
    url: login + "/auth/oauth/token",
    headers: {
      isToken: false,
      ORG_ID: "1",
      Authorization: "Basic Y2huX2g1X3YzMDp2MzBfY2huX2g1"
    },
    method: "post",
    params: { refresh_token, grant_type, scope }
  });
}
//退出
export function logOut() {
  const partnerplan_access_token = localStorage.getItem(
    "partnerplan_access_token"
  );

  return axios({
    url: login + `/auth/token/logout`,
    headers: {
      TOKEN: true,
      Authorization: "Bearer " + partnerplan_access_token
    },
    method: "delete"
  });
  // return request.delete("/auth/token/logout", {
  //   TOKEN: true
  // });
}
//获取用户信息
export function getUserinfo() {
  const partnerplan_access_token = localStorage.getItem(
    "partnerplan_access_token"
  );

  return axios({
    url: login + `/kernel/user/info`,
    headers: {
      TOKEN: true,
      Authorization: "Bearer " + partnerplan_access_token
    },
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js